import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withSearchHandler } from 'decorators';
import MapPin from 'components/svg/MapPin';
import { SearchBox } from 'components/molecules/SearchBox';
import { Paragraph, Image, Container, Section, H1 } from 'components/atoms';

import './CTABlock.scss';

export const enhance = compose(withSearchHandler);

export function CTABlock({ content, handleSearch }) {
	const { storageType, location, image, subLabel } = content;

	return (
		<Section className="inline-cta-section">
			<Container>
				<div className="inline-cta">
					<div className="inline-cta-search-box">
						<H1
							className="inline-cta-search-box-label"
							color="black"
						>
							Find {storageType} Storage Units in {location}
						</H1>
						<Paragraph className="inline-cta-search-box-sublabel">
							{subLabel}
						</Paragraph>
						<SearchBox
							inputLabel="Enter address, city, or zip"
							onSearch={handleSearch}
							icon={<MapPin fill="gray" />}
							useBrowserLocation
							withSearchType={false}
						/>
					</div>

					<Image
						className="inline-cta-image"
						src={image}
						alt="inline-cta-image"
						width={679}
						height={381}
					/>
				</div>
			</Container>
		</Section>
	);
}

CTABlock.propTypes = {
	handleSearch: PropTypes.func.isRequired,
	content: PropTypes.object,
};

export default enhance(CTABlock);
